import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventListingSwitch = (listingType: "offers" | "properties") => {
    hitGoogleTagManager({
        event: "listing_switch",
        switch_type: listingType === "offers" ? "osielde" : "mieszkanie"
    });
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventListingSwitch = (listingType: "offers" | "properties") => {
    hitGoogleTagManager({
        event: "listing_switch",
        switch_type: listingType === "offers" ? "osielde" : "mieszkanie"
    });
};
